import { render, staticRenderFns } from "./Interventions.vue?vue&type=template&id=c5f338c0"
import script from "./Interventions.vue?vue&type=script&lang=ts"
export * from "./Interventions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5f338c0')) {
      api.createRecord('c5f338c0', component.options)
    } else {
      api.reload('c5f338c0', component.options)
    }
    module.hot.accept("./Interventions.vue?vue&type=template&id=c5f338c0", function () {
      api.rerender('c5f338c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/projectDetails/CarePlanRightSide/Interventions.vue"
export default component.exports